/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const OrderSource = {
  SquareMigration: "SQUARE_MIGRATION",
  InPerson: "IN_PERSON",
  Online: "ONLINE",
} as const;

export type OrderSource = (typeof OrderSource)[keyof typeof OrderSource];

export type OrderSourceEnumType = typeof OrderSource;
export type OrderSourceOptional = OrderSource;
export type OrderSourceTrackedI = OrderSource;
export type OrderSourceTracked = OrderSource;
export type OrderSourceMetaI = EnumMetaType<OrderSourceEnumType, OrderSource>;
export const OrderSourceMeta = typeMetaEnum<OrderSourceEnumType, OrderSource>(
  "OrderSource",
  OrderSource,
);
export function transformDatesOrderSource(model: OrderSource) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
